import log from '@/utils/log'

export default {
	name: 'ErrorBoundary',
	data: () => ({
		hasError: false
	}),
	errorCaptured(err, _, info) {
		log.error(`Vue error: ${info}`, null, err.stack)
		this.hasError = true
	},
	render() {
		// TODO: render error page..
		// return this.hasError ? h('p', 'Sorry. Something went wrong. :(') : this.$slots.default[0]
		return this.$slots.default ? this.$slots.default[0] : null
	}
}
